import { useState, useEffect } from 'react';

export const useShiftKeyPress = () => {
  const [shiftKeyPressed, setShiftKeyPressed] = useState(false);
  const SHIFT_KEY_CODE = 16;
  const keyDownListener = (keyPressEvent) => {
    const keyCode = keyPressEvent.keyCode || keyPressEvent.charCode || 0;
    if (keyCode === SHIFT_KEY_CODE) {
      setShiftKeyPressed(true);
    }
  };
  const keyUpListener = (keyPressEvent) => {
    const keyCode = keyPressEvent.keyCode || keyPressEvent.charCode || 0;
    if (keyCode === SHIFT_KEY_CODE) {
      setShiftKeyPressed(false);
    }
  };
  useEffect(() => {
    document.addEventListener('keydown', keyDownListener);
    return () => document.removeEventListener('keydown', keyDownListener);
  });
  useEffect(() => {
    document.addEventListener('keyup', keyUpListener);
    return () => document.removeEventListener('keyup', keyUpListener);
  });
  return shiftKeyPressed;
};
